import { graphql, useStaticQuery } from "gatsby";

// Todo: TS Replace with kontent interface
interface SitePages {
  links: {
    nodes: Queries.InternalLinks[];
  };
}

const getSitePages = (): SitePages => useStaticQuery<SitePages>(graphql`
  {
    links: allInternalLinks {
      nodes {
        id
        nodeId
        parentId
        slug
        systemId
        title
      }
    }
  }
`);

export default getSitePages;
